export const PERMISSION_REF_WMS_CHART_CONSUMER = 'wms-map-consumer';
